module.exports = __webpack_public_path__ + "img/banner.8165a9b0.jpg";